
import axios from "axios"
import router from '../../router';

import { func } from '../../main';


const state = {
    WorkGroups: [],
    Loading:false
};


const getters = {
    GetWorkGroupsList(state: { WorkGroups: any; }) {
        return state.WorkGroups;
    }
};

const mutations = {
    SetWorkGroupList(state: { WorkGroups: any; }, list: any) {
        state.WorkGroups = list;
    }
};

const actions = {

    GetWorkGroupListFromServer(context, Filter: any) {
        context.commit("SetLoading", true);
        axios.get("InviteUser/GetAllisEnable", {
                params: {
                    text: Filter.taskId,
                    workGroupId: Filter.workGroupId
                }
        })
            .then((data: any) => {
                context.commit("SetLoading", false);
                context.commit("SetWorkGroupList", data.data);
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
